<div class="container mt-5">
    <div class="text-center">
        <h1 class="error-404">404</h1>
        <h3 class="mb-4">Desculpe, esta página não está disponível.</h3>
        <button type="button" class="btn btn-outline-info" [routerLink]="['/home']">Retornar para o sistema</button>
    </div>
</div>
